import * as React from "react";
import type { SVGProps } from "react";
const SvgPrevious = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.02 12H20M8.018 16.001 4.017 12l4.001-4.001M20 16V8"
    />
  </svg>
);
export default SvgPrevious;
